/**
 * Canonical Firestore collection ids (main app).
 * Align with: backend/src/config/firestoreCollections.ts and functions/src/firestoreCollections.ts
 * COMPANY_USER_LIVE_FIELD_KEYS: keep in sync with backend/src/config/firestoreCollections.ts
 */

export const FIRESTORE_COLLECTIONS = {
  COMPANY_USERS: 'companyUsers',
  COMPANIES: 'companies',
  /** High-churn presence/location; merged into profile reads in MigrationDataAccessLayer */
  COMPANY_USER_LIVE: 'companyUserLive',
  /** ACI Phase 3; backend-only writes. Client must not read (rules deny). */
  ACI_INTERNAL_REGULATORY_SNAPSHOTS: 'aciInternalRegulatorySnapshots',
  /** ACI Phase 4.4; backend-only writes. Client must not read (rules deny). */
  ACI_LINKAGE_ANALYST_FEEDBACK: 'aciLinkageAnalystFeedback',
  /** ACI Phase 4; backend-only persisted preview runs. Client must not read (rules deny). */
  ACI_INTERNAL_LINKAGE_PREVIEW_RUNS: 'aciInternalLinkagePreviewRuns',
  /** ACI Phase 5.1 — Admin SDK only; mirror backend `FIRESTORE_COLLECTIONS`. */
  ACI_INTERNAL_BEHAVIOR_EVENTS: 'aciInternalBehaviorEvents',
  /** ACI Phase 6.1 — Admin SDK only; mirror backend `FIRESTORE_COLLECTIONS`. */
  ACI_INTERNAL_CASES: 'aciInternalCases',
  /** ACI Phase 6.2 — Admin SDK only; mirror backend `FIRESTORE_COLLECTIONS`. */
  ACI_INTERNAL_CASE_ACTIONS: 'aciInternalCaseActions',
  /** ACI Phase 6.3 — Admin SDK only; mirror backend `FIRESTORE_COLLECTIONS`. */
  ACI_INTERNAL_REGULATORY_SHARE_INTENTS: 'aciInternalRegulatoryShareIntents',
} as const;

/** Fields stored on companyUserLive to avoid firing companyUsers onUpdate on every GPS/heartbeat tick */
export const COMPANY_USER_LIVE_FIELD_KEYS = [
  'status',
  'lastActive',
  'location',
  'lastLocation',
  /** Broker/carrier availability map coords (brokerService.updateCarrierAvailability) */
  'currentLocation',
] as const;

export type CompanyUserLiveFieldKey = (typeof COMPANY_USER_LIVE_FIELD_KEYS)[number];

export type FirestoreCollectionName =
  (typeof FIRESTORE_COLLECTIONS)[keyof typeof FIRESTORE_COLLECTIONS];
